import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';
import {Trade} from "./trade";
import CallPut = Trade.CallPut;

export class ClearingSelectionInfo {

  @JsonProperty()
  owner: string;
  @JsonProperty()
  side: Trade.Side | undefined;
  @JsonProperty()
  clearingHouse: string;
  @JsonProperty()
  exchangeCode: string;
  @JsonProperty()
  maturity: string;
  @JsonProperty()
  contract: string;
  @JsonProperty()
  totalVolume: number;
  @JsonProperty()
  buyTotalVolume: number;
  @JsonProperty()
  sellTotalVolume: number;
  @JsonProperty()
  totalClearingVolume: number;
  @JsonProperty()
  avgTotalPrice: number;
  @JsonProperty()
  apsGrpTotalVolume: number;
  @JsonProperty()
  unmatchedTotalVolume: number;
  @JsonProperty()
  apsGrpTotalPrice: number;
  @JsonProperty()
  parentId: string;
  @JsonProperty()
  reference: string;
  @JsonProperty()
  state: string;

  @JsonProperty()
  callPut: CallPut;
  @JsonProperty()
  strike: number;

  @JsonProperty()
  price: number;
  @JsonProperty()
  trader: string;
  @JsonProperty()
  operatorId: string;
  @JsonProperty()
  accountName: string;
  @JsonProperty()
  accountType: string;
  @JsonProperty()
  customOrderRef: string;

  @JsonProperty()
  strategy: string;
  @JsonProperty()
  freeText1: string;
  @JsonProperty()
  freeText2: string;

  @JsonProperty()
  sortField?: string;

  @JsonProperty()
  disabled: boolean;

  @JsonProperty()
  itemIds?: string[] = [];

  @JsonProperty()
  additionalFields?: {} = {};

}

